import React from "react";
import { useNavigate } from "react-router-dom";

const PricingCard = ({ plans, category }) => {
  const navigate = useNavigate();

  const handlePortfolioClick = () => {
    if (category) {
      navigate(`/portfolio?category=${category}`);
    } else {
      navigate("/portfolio");
    }
  };

  return (
    <div className="w-full bg-gradient-to-br from-slate-50 via-white to-teal-50/30 px-6 py-12">
      <div className="max-w-[1240px] mx-auto">
        {/* Pricing Cards Grid */}
        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {plans.map((plan, index) => (
            <div
              key={index}
              className="w-full shadow-lg flex flex-col justify-between p-8 rounded-lg hover:scale-105 duration-300 bg-white border-2 border-transparent hover:border-teal-500 transition-all group"
            >
              <h2 className="text-2xl font-light text-center py-8 text-gray-900 group-hover:text-teal-600 transition-colors">
                {plan.title}
              </h2>
              <p className="text-center text-4xl font-extralight text-teal-600">
                {plan.price}
              </p>
              <div className="text-center font-light flex-grow flex flex-col justify-start">
                {plan.features.map((feature, index) => (
                  <p
                    key={index}
                    className={`py-3 border-b border-gray-200 mx-8 text-gray-700 ${
                      index === 0 ? "mt-8" : ""
                    }`}
                  >
                    {feature}
                  </p>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Terms and Conditions */}
        <div className="mb-8">
          <div className="bg-teal-50/50 border border-teal-200 rounded-lg p-4 sm:p-6 space-y-3 sm:space-y-4">
            <p className="text-sm sm:text-sm text-gray-700 leading-relaxed">
              <span className="font-medium">*</span>By booking a shoot, you automatically agree to the use of the photos on social media and website unless agreed otherwise in advance.
            </p>
            <p className="text-sm sm:text-sm text-gray-700 leading-relaxed">
              <span className="font-medium">**</span>Prices include VAT. Travel charges are included till 100 km . Additional travel charges will be applied above 100 km at €0.25 per km. Parking costs are not included.
            </p>
            <p className="text-sm sm:text-sm text-gray-700 leading-relaxed">
              <span className="font-medium">***</span>Extra photos can be purchased for €10 each.
            </p>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row justify-center items-center gap-6">
          <button
            onClick={() => navigate('/book-now')}
            className="group/btn relative overflow-hidden bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 text-white duration-150 w-full sm:w-[200px] rounded-md font-light px-6 py-3 tracking-widest text-sm uppercase transition-all transform hover:shadow-lg hover:scale-105"
          >
            <span className="relative z-10">Book Now</span>
            <div className="absolute inset-0 bg-gradient-to-r from-teal-400 to-teal-500 opacity-0 group-hover/btn:opacity-100 transition-opacity duration-500"></div>
          </button>
          <button
            onClick={handlePortfolioClick}
            className="group/btn relative overflow-hidden bg-white border-2 border-teal-500 text-teal-600 hover:bg-teal-50 duration-150 w-full sm:w-auto rounded-md font-light px-6 py-3 tracking-widest text-sm uppercase transition-all transform hover:shadow-lg hover:scale-105 whitespace-nowrap"
          >
            <span className="relative z-10">Check Portfolio</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default PricingCard;
